import { render, staticRenderFns } from "./sourceOverall.vue?vue&type=template&id=2c80f131&scoped=true"
import script from "./sourceOverall.vue?vue&type=script&lang=js"
export * from "./sourceOverall.vue?vue&type=script&lang=js"
import style0 from "./sourceOverall.vue?vue&type=style&index=0&id=2c80f131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c80f131",
  null
  
)

export default component.exports